import { render } from "./Imc.vue?vue&type=template&id=13c95c94&scoped=true&ts=true"
import script from "./Imc.vue?vue&type=script&lang=ts"
export * from "./Imc.vue?vue&type=script&lang=ts"

import "./Imc.vue?vue&type=style&index=0&id=13c95c94&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c95c94"]])

export default __exports__